module.exports = __webpack_public_path__ + "img/20201112-4.86a9f43f.jpg";